export default __webpack_public_path__ + "ad6e45873823687e1bd9b6128c30ff4a.jpg";